'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AlertFailure = require('./components/AlertFailure.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_AlertFailure).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ../biblio-ui-glue/src/base/alerts/lib/components/failure/index.js
// module id = 360
// module chunks = 0 1 4